module.exports = __webpack_public_path__ + "img/img-map-style-satellite.e6046863.png";